import { zoneProjectsRetrievalError } from "@planzone/dto";
import { areZoneProjectsRetrievalFilters } from "../../utils/areZoneProjectsRetrievalFilters";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getZoneProjectsRetrievalError({ uuid }, filter) {
      const res = getState().find(
        ({ zone, filter: f }) =>
          zone.uuid === uuid && areZoneProjectsRetrievalFilters(filter, f),
      );

      return res ? res.error : zoneProjectsRetrievalError;
    },
    getZoneProjects({ uuid }, filter) {
      const res = getState().find(
        ({ zone, filter: f }) =>
          zone.uuid === uuid && areZoneProjectsRetrievalFilters(filter, f),
      );

      return res ? res.projects : [];
    },
    isZoneProjectsRetrievalRequestFailure({ uuid }, filter) {
      const res = getState().find(
        ({ zone, filter: f }) =>
          zone.uuid === uuid && areZoneProjectsRetrievalFilters(filter, f),
      );

      return res ? res.request.isFailure : false;
    },
    isZoneProjectsRetrievalRequestPending({ uuid }, filter) {
      const res = getState().find(
        ({ zone, filter: f }) =>
          zone.uuid === uuid && areZoneProjectsRetrievalFilters(filter, f),
      );

      return res ? res.request.isPending : false;
    },
    isZoneProjectsRetrievalRequestSuccess({ uuid }, filter) {
      const res = getState().find(
        ({ zone, filter: f }) =>
          zone.uuid === uuid && areZoneProjectsRetrievalFilters(filter, f),
      );

      return res ? res.request.isSuccessful : false;
    },
    canRetrieveNextZoneProjects({ uuid }, filter) {
      const res = getState().find(
        ({ zone, filter: f }) =>
          zone.uuid === uuid && areZoneProjectsRetrievalFilters(filter, f),
      );

      return res ? res.canRetrieveNextProjects : true;
    },
    getZoneProjectsCallCount({ uuid }, filter) {
      const res = getState().find(
        ({ zone, filter: f }) =>
          zone.uuid === uuid && areZoneProjectsRetrievalFilters(filter, f),
      );

      return res ? res.callCount : 0;
    },
  };
}

export { createSelector };
